import { LessonStatus } from '@/lib/constants';
import { queryKeys, USER_DATA_STALE_TIME } from '@/lib/queryClient';
import { fetchContinueLessonsForDashboard } from '@/supabase/services/optimizedCourse';
import { useQuery } from '@tanstack/react-query';
import { purchasedCoursesCategoryQueryOptions } from './purchasedCoursesQueries';

export function usePurchasedCoursesPageData(userId: string | null | undefined) {
  const categoryUserId = userId ?? null;

  const purchasedCategoryQuery = useQuery(
    purchasedCoursesCategoryQueryOptions(categoryUserId),
  );

  const continueLessonsQuery = useQuery({
    queryKey: queryKeys.purchasedCourses.continue(categoryUserId),
    queryFn: () =>
      fetchContinueLessonsForDashboard(
        userId ?? null,
        undefined,
        [],
        LessonStatus.Published,
        [],
        true,
        true,
      ),
    staleTime: USER_DATA_STALE_TIME,
    enabled: !!userId,
    gcTime: 1 * 60 * 1000,
  });

  const isLoading =
    purchasedCategoryQuery.isLoading || continueLessonsQuery.isLoading;

  const error = purchasedCategoryQuery.error ?? continueLessonsQuery.error;

  return {
    purchasedCourses: purchasedCategoryQuery.data?.courses ?? [],
    continueLessons: continueLessonsQuery.data ?? [],
    isLoading,
    error: error instanceof Error ? error : error ? new Error(String(error)) : null,
    refetch: async () => {
      await Promise.all([
        purchasedCategoryQuery.refetch(),
        continueLessonsQuery.refetch(),
      ]);
    },
  };
}
